import React from 'react'

export default function FormLogIn(props) {
    const { inputHandler, buttonHandler, webtoken } = props
    return (
        <div>
            <form 
                className="d-flex flex-column p-5"
                onSubmit={ e => e.preventDefault()}>
                <h2
                    className="title-form"
                >Welcome to DEV Community</h2>
                <label 
                    className="input-labels mt-3" 
                    htmlFor="email">Email
                </label>
                <input 
                    className="" 
                    type="text"
                    name="email"
                    onChange={ inputHandler }
                />
                <label 
                    className="input-labels mt-3" 
                    htmlFor="password">Password
                </label>
                <input 
                    className="mb-3" 
                    type="text"
                    name="password"
                    onChange={ inputHandler }
                />
                {
                    !webtoken && 
                        <div className=" w-100 d-flex justify-content-center">
                            <p className="text-danger">
                                Please enter valid credentials
                            </p>
                        </div>
                }
                <button 
                    className="mt-1 rounded text-white sign-in-btn p-2" 
                    onClick={ buttonHandler }
                    > Continue 
                </button>
            </form>
        </div>
    )
}
